import { ReactNode } from 'react';
import { Typography } from '@rossum/ui/material';

export const boldText = (chunks: ReactNode[]) => (
  <Typography variant="inherit" component="span" sx={{ fontWeight: 'bold' }}>
    {chunks}
  </Typography>
);
